import { ClipControls } from "../../parameterWidgets/ClipControls";
import { GrufModulEQ, GrufModulSends } from "../../components/moduls";
import { ParameterKnob } from "../../parameterWidgets/ParameterKnob";
import { GrooveboxSequencer } from "../../parameterWidgets/GrooveboxSequencer";
import SeparatorLine from "jsx:$assets/widgets/separator_line.svg";
import { HelpBox } from "../../components/HelpBox";
import { PresetBankBar } from "../../parameterWidgets/PresetBankBar";
import { useState } from "react";
import { MidiPad } from "../../components/MidiPad";
import { useDispatch, useSelector } from "react-redux";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

export const GrooveBoxUI = ({instrument}) => {
    const [selectedPlayerName, setSelectedPlayerName] = useState(instrument.playerNames[0]);
    return (
        <div key={instrument.id} className="estacio estacio-groovebox" style={{"--accent-color": instrument.metadata.color}}>
            <PresetBankBar instrument={instrument} className="col-span-2" />
            <div className="col-span-3"/>

            <div className="modul-border modul-bg flex justify-between col-span-2 items-center">
                <ParameterKnob data-widget-id="instrumentVolume" mida="gran" parameterHandler={instrument.getParameterHandler("gain")} />
                <SeparatorLine className="h-full"/>
                <ParameterKnob data-widget-id="lpfCutoff" mida="gran" parameterHandler={instrument.getParameterHandler("lpf_cutoff")} />
            </div>
    
            <GrufModulEQ instrument={instrument} />
            <GrufModulSends instrument={instrument} />
            <HelpBox instrument={instrument} />

            <fieldset className="flex flex-col justify-around modul-border" key={selectedPlayerName} style={{borderColor: instrument.getPlayerColor(selectedPlayerName)}}>
                <ParameterKnob data-widget-id="drumVol" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler(`${selectedPlayerName}_volume`)} />
                <ParameterKnob data-widget-id="drumTone" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler(`${selectedPlayerName}_tone`)} />
                <ParameterKnob data-widget-id="drumRelease" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler(`${selectedPlayerName}_release`)} />
                <ParameterKnob data-widget-id="drumReverb" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler(`${selectedPlayerName}_reverbSend`)} />
                <ParameterKnob data-widget-id="drumSwing" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler(`${selectedPlayerName}_swing`)} />
            </fieldset>
            <fieldset className="groovebox-pads">
                {instrument.playerNames.map(playerName => {
                    const isSelected = selectedPlayerName === playerName;
                    const color = instrument.getPlayerColor(playerName);
                    return <div className="relative">
                        <div className="groovebox-pad-wrapper">
                            { isSelected && <svg viewBox="0 0 1 2" preserveAspectRatio="none" className="center-absolute h-full" style={{width: 135}}>
                                    <line x1="0" x2="1" y1="1" y2="1" stroke={color} vectorEffect="non-scaling-stroke" />
                                </svg>}
                            <MidiPad
                                data-widget-id="drumPad"
                                className="groovebox-pad w-full"
                                style={{"--accent-color": color}}
                                instrument={instrument}
                                isSelected={isSelected}
                                pitch={instrument.getPlayerPitch(playerName)}
                                setSelected={() => setSelectedPlayerName(playerName)}
                                label={instrument.getPlayerLabel(playerName)}
                                />
                        </div>
                        <PlayerDrumkitSelector instrument={instrument} playerName={playerName} /> 
                    </div>
                })}
            </fieldset>
            <GrooveboxSequencer className="col-span-3" instrument={instrument} />

            <div />
            <ClipControls className="col-span-4 justify-self-end" instrument={instrument} />
        </div>
    );
};

function PlayerDrumkitSelector({instrument, playerName}) {
    const handler = instrument.getParameterHandler(`${playerName}_drumkit`);
    const value = useSelector(handler.selector);

    // if there's a number, we don't want to cut it with the ellipsis
    const nameWithNumber = value.match(/^(.*?) (\d)$/);
    let name = value;
    let number = undefined;
    if (nameWithNumber) [_, name, number] = nameWithNumber;

    const options = handler.description.options;
    const currentIndex = handler.real2Num(value);
    const previousOption = options[(currentIndex - 1 + options.length) % options.length];
    const nextOption = options[(currentIndex + 1 + options.length) % options.length];
    const dispatch = useDispatch();

    return <div data-widget-id="drumDrumkit" className="flex justify-between items-center absolute" style={{inset: "50px 50%", translate: "-50%", width: 125}}>
        <button className="center-grid" onClick={() => dispatch(handler.updater(previousOption))}><ChevronLeftIcon/></button>
            <span className="flex" style={{whiteSpace: "nowrap", minWidth: 0}}>
            <span className="ellipsis" style={{overflow: "hidden"}}>
                {name}
            </span>
            {nameWithNumber && <span>&nbsp;{number}</span>}
        </span>
        <button className="center-grid" onClick={() => dispatch(handler.updater(nextOption))}><ChevronRightIcon /></button>
    </div>
}